import { PaginationInstance } from "ngx-pagination/dist/pagination-instance";

export class TableState implements PaginationInstance {
    public searchText : string = null;
    public propertyName : string = null;
    public sortOrder: string = 'DESC';
    id: string;
    public currentPage: number = 1;
    public itemsPerPage: number = 10;
    public totalItems: number = 0;
    public updating: boolean = false;

    private selectedClass(columnName): string {
        return columnName == this.propertyName ? 'sort-' + (this.sortOrder == 'DESC') : '';
    }

    private changeSorting(columnName): boolean {
        if (this.updating || !columnName) {
            return;
        }
        if (this.propertyName == columnName) {
            this.sortOrder = this.sortOrder == 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.propertyName = columnName;
            this.sortOrder = 'DESC';
        }
        return true;
    }

    public pageChange(page: any): void {
        if (this.updating) {
            return;
        }
        this.currentPage = parseInt(page);
    }

    public pageCount(): number {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    }

    public updateFilterField(filterProp: string, conditionProp: string) {
        if (this[filterProp] && this[filterProp].length > 0) {
            this[filterProp] =
                (this[conditionProp] == 1 || this[conditionProp] == 2 ? '%' : '') +
                this[filterProp] +
                (this[conditionProp] == 0 || this[conditionProp] == 1 ? '%' : '');
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/table-state.ts